document.addEventListener("DOMContentLoaded",()=>{

const drawer=document.querySelector(".ph-drawer");

const open=document.querySelector(".ph-menu-toggle");

const close=document.querySelector(".ph-close");

const overlay=document.querySelector(".ph-overlay");

if(!drawer||!open) return;

function openDrawer(){

drawer.classList.add("active");

document.body.style.overflow="hidden";

}

function closeDrawer(){

drawer.classList.remove("active");

document.body.style.overflow="";

}

open.addEventListener("click",openDrawer);

close.addEventListener("click",closeDrawer);

overlay.addEventListener("click",closeDrawer);

document.addEventListener("keydown",e=>{

if(e.key==="Escape"){

closeDrawer();

}

});

});

document.querySelectorAll(".ph-submenu-toggle").forEach(button => {

    button.addEventListener("click", function(){

        const item = this.closest(".ph-menu-item");
        const submenu = item.querySelector(".ph-submenu");

        document.querySelectorAll(".ph-menu-item.open").forEach(openItem => {

            if(openItem !== item){

                const openSub = openItem.querySelector(".ph-submenu");

                openItem.classList.remove("open");

                if(openSub){

                    openSub.style.maxHeight = null;

                }

            }

        });

        item.classList.toggle("open");

        if(item.classList.contains("open")){

            submenu.style.maxHeight = submenu.scrollHeight + "px";

        }else{

            submenu.style.maxHeight = null;

        }

    });

});